// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> weidner-apartment-homes-rise-rise -> villas-at-countryside-apartment-homes
// Generated: 2026-10-27T17:15:42.793Z
// Counts: 0 design, 27 content, 7 slot group, 0 collection binding, 9 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready for a fresh take on apartment life? Villas at Countryside lets you settle into a north Moore neighborhood surrounded by it all - from everyday shopping at Walmart to big-league fun at Paycom Center and the outdoor spaces of Scissortail Park. Enjoy the easy access to I-35 and I-240, making it simple to reach work or play in downtown Oklahoma City and the wider metro area. At Villas at Countryside, you'll spend less time commuting and more time enjoying Moore's vibrant community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "VALUE",
    "customValue": "<p>At Villas at Countryside, thoughtful features greet you at every turn. Step into a lifestyle where vaulted ceilings, stainless steel appliances, and in-unit laundry add ease and a touch of elegance to your living space. Step outside for sunny afternoons by the sparkling pool, grill up your favorites at the community stations, or let your pet run free at the on-site park. Here, home is comfortable, welcoming, and designed for the way you want to live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=48/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments In <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>LOVE WHERE YOU LIVE</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Live the lifestyle you deserve at Villas at Countryside apartments in Moore, OK. With a full range of in-home upgrades and vibrant community spaces, each day feels comfortable and convenient. Enjoy in-home laundry, vaulted ceilings, modern kitchens, and plenty of storage, all matched by inviting amenities outside your door that make relaxation and recreation part of everyday life.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We're here to help you take the next step toward calling Villas at Countryside home. Reach out to our professional leasing team with your questions about floor plans, availability, or living in Moore, OK. We look forward to helping you discover your perfect apartment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore apartments for rent in Moore, OK, that are designed with both comfort and flexibility in mind. At Villas at Countryside, the one- and two-bedroom floor plans feature spacious living areas, open-concept kitchens, and storage to keep life organized. Create your own WFH setup, unwind on your private patio or balcony, and enjoy in-home touches that support your daily routine and leisure time.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture your life at Villas at Countryside in Moore, OK. Our gallery invites you into real spaces where modern kitchens, designer lighting, and relaxing patios set the tone for everyday life. Browse images of inviting community amenities, from the sparkling pool to the bustling clubhouse and cozy business center. Take a visual stroll through your potential new home and get inspired to make it yours.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the energy of North Moore at Villas at Countryside, where you're always close to dining, retail, entertainment, and major roadways. Enjoy national retailers and a variety of restaurants minutes from your door, with easy access to Interstates 35 and 240 for quick trips to work or play. Major employers and the excitement of downtown Oklahoma City are just a short commute away, while local parks and walking trails invite you to unwind and explore the neighborhood. Life here puts you in the heart of everything Moore has to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Pit Bull &amp; Pit Bull Mixes&nbsp;</p></li><li><p>American Pit Bull Terrier&nbsp;</p></li><li><p>American Staffordshire Terrier&nbsp;</p></li><li><p>Wolf Hybrids&nbsp;</p></li><li><p>Doberman Pinscher&nbsp;</p></li><li><p>Saint Bernard&nbsp;</p></li><li><p>American Bulldog&nbsp;</p></li><li><p>Staffordshire Bull Terrier&nbsp;</p></li><li><p>Rottweiler&nbsp;</p></li><li><p>German Shepherd&nbsp;</p></li><li><p>Chow Chow&nbsp;</p></li><li><p>Great Dane&nbsp;</p></li><li><p>Akita</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Connected Living in North Moore</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to see your next home? Villas at Countryside makes exploring easy with flexible tour options. Choose a live virtual walk-through or an in-person visit guided by our leasing professionals - all designed to fit your schedule. Discover the layout, features, and community perks that make Villas at Countryside a top choice for apartments for rent in Moore, OK. We'll make sure you get the vibe, feel the flow, and see the details that matter to you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Comfort and Community Await</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a real feel for life at Villas at Countryside, no matter where you are. Our virtual tour lets you step inside actual apartments and community spaces, helping you picture your days at home in Moore, OK. Discover the flow of open-concept layouts, the convenience of walk-in closets, and the welcoming community vibe. Whether you're exploring options or planning your move, a virtual tour is the easy way to imagine how Villas at Countryside fits your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.address": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_google_business_url"
      }
    }
  },
  "footer.love_notes_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3412-75a9-9aac-8f5678cb59df.webp"
      }
    }
  },
  "footer.weidner_cares_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3452-767e-8966-83b6939f057f.webp"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "tabbedcallouts.panel3_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 10
    }
  ]
};

export const styleOverrides = {};
